import React from 'react';
import { useLanguage } from '@/App';
import { ScrollReveal } from '@/components/ScrollReveal';
import { Instagram } from 'lucide-react';

const CampaignExamples = () => {
  const { language } = useLanguage();

  const content = {
    tr: {
      title: 'Kampanyalarımızdan',
      titleHighlight: 'Örnekler',
      subtitle: 'Son 2 yılda gerçekleştirdiğimiz çoklu influencer kampanyalarımızdan bazı örnekler.',
      instagramCta: 'Daha fazlası için Instagram sayfamızı ziyaret edin',
      campaigns: [
        {
          brand: 'ebebek',
          logo: '/brands/ebebek.png',
          date: 'Şub 2026',
          description: '16 influencer · 1 ayda 200+ içerik · Şubat indirimi iletişimi'
        },
        {
          brand: 'Molfix',
          logo: '/brands/molfix.png',
          date: 'Oca 2026',
          description: '3 influencer · bebek bezi tanıtımı'
        },
        {
          brand: 'Tecno Mobile',
          logo: '/brands/tecno.png',
          date: 'Ara 2025',
          description: '20 influencer · CAMON 40 lansmanı'
        },
        {
          brand: 'Pastel',
          logo: '/brands/pastel.png',
          date: 'Ara 2025',
          description: '6 influencer · yeni maskara lansmanı'
        },
        {
          brand: 'ROCS',
          logo: '/brands/rocs.png',
          date: 'Kas 2025',
          description: '6 influencer · diş beyazlatıcı tanıtımı'
        },
        {
          brand: 'Prozinc',
          logo: '/brands/prozinc.png',
          date: 'Eki 2025',
          description: '24 influencer · şampuan serisi tanıtımı'
        },
        {
          brand: 'Prozinc',
          logo: '/brands/prozinc.png',
          date: 'Ağu 2025',
          description: '36 influencer · şampuan serisi tanıtımı'
        },
        {
          brand: 'ebebek',
          logo: '/brands/ebebek.png',
          date: 'Tem 2025',
          description: '35 influencer · 105 Reel · 20M+ görüntülenme · ürün grubu tanıtımı'
        },
        {
          brand: 'Tecno Mobile',
          logo: '/brands/tecno.png',
          date: 'Haz 2025',
          description: '100+ TikTok içerik üreticisi · 300+ içerik · yeni ürün lansmanı'
        },
        {
          brand: 'Shevec',
          logo: '/brands/shevec.png',
          date: 'Ara 2024',
          description: '15 influencer · PR kampanyası'
        },
        {
          brand: 'Braun',
          logo: '/brands/braun.png',
          date: 'May 2024',
          description: '5 influencer · 10M+ izlenme · yeni saç şekillendiricisi lansmanı'
        }
      ]
    },
    en: {
      title: 'Campaign',
      titleHighlight: 'Examples',
      subtitle: 'Some examples from our multi-influencer campaigns over the past 2 years.',
      instagramCta: 'Visit our Instagram page for more',
      campaigns: [
        {
          brand: 'ebebek',
          logo: '/brands/ebebek.png',
          date: 'Feb 2026',
          description: '16 influencers · 200+ content in 1 month · February discount campaign'
        },
        {
          brand: 'Molfix',
          logo: '/brands/molfix.png',
          date: 'Jan 2026',
          description: '3 influencers · baby diaper promotion'
        },
        {
          brand: 'Tecno Mobile',
          logo: '/brands/tecno.png',
          date: 'Dec 2025',
          description: '20 influencers · CAMON 40 launch'
        },
        {
          brand: 'Pastel',
          logo: '/brands/pastel.png',
          date: 'Dec 2025',
          description: '6 influencers · new mascara launch'
        },
        {
          brand: 'ROCS',
          logo: '/brands/rocs.png',
          date: 'Nov 2025',
          description: '6 influencers · teeth whitener promotion'
        },
        {
          brand: 'Prozinc',
          logo: '/brands/prozinc.png',
          date: 'Oct 2025',
          description: '24 influencers · shampoo series promotion'
        },
        {
          brand: 'Prozinc',
          logo: '/brands/prozinc.png',
          date: 'Aug 2025',
          description: '36 influencers · shampoo series promotion'
        },
        {
          brand: 'ebebek',
          logo: '/brands/ebebek.png',
          date: 'Jul 2025',
          description: '35 influencers · 105 Reels · 20M+ views · product group promotion'
        },
        {
          brand: 'Tecno Mobile',
          logo: '/brands/tecno.png',
          date: 'Jun 2025',
          description: '100+ TikTok creators · 300+ content · new product launch'
        },
        {
          brand: 'Shevec',
          logo: '/brands/shevec.png',
          date: 'Dec 2024',
          description: '15 influencers · PR campaign'
        },
        {
          brand: 'Braun',
          logo: '/brands/braun.png',
          date: 'May 2024',
          description: '5 influencers · 10M+ views · new hair styler launch'
        }
      ]
    }
  };

  const t = content[language];

  return (
    <section className="pt-6 pb-12 bg-black bg-opacity-75" data-testid="campaign-examples-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <ScrollReveal>
          <div className="text-center mb-6 md:mb-8">
            <h2 className="text-2xl md:text-4xl font-bold">
              <span className="text-white">{t.title} </span>
              <span className="text-[#FFDD59]">{t.titleHighlight}</span>
            </h2>
            <p className="text-gray-400 mt-2 md:mt-3 text-sm md:text-lg px-2">
              {t.subtitle}
            </p>
          </div>
        </ScrollReveal>

        {/* Campaign Cards Grid - Column-first layout on desktop, normal on mobile */}
        <div 
          className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-6 campaign-grid"
        >
          {t.campaigns.map((campaign, index) => (
            <ScrollReveal key={index} delay={index * 50}>
              <div 
                className="flex items-center rounded-xl overflow-hidden"
                style={{
                  backgroundColor: '#141414',
                  border: '0.5px solid rgba(255,255,255,0.08)',
                  borderRadius: '12px'
                }}
              >
                {/* Brand Logo - No gap, attached to card */}
                <div 
                  className="flex-shrink-0 bg-white flex items-center justify-center"
                  style={{ width: '56px', height: '56px', padding: '8px' }}
                >
                  <img 
                    src={campaign.logo} 
                    alt={campaign.brand}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
                
                {/* Content */}
                <div className="flex-1 min-w-0 px-3 md:px-4 py-2 md:py-3">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="text-sm md:text-base font-bold text-white truncate">
                      {campaign.brand}
                    </h3>
                    <span className="text-[10px] md:text-xs text-gray-400 italic flex-shrink-0">
                      {campaign.date}
                    </span>
                  </div>
                  <p className="text-[10px] md:text-xs text-gray-400 leading-snug mt-0.5 line-clamp-2">
                    {campaign.description}
                  </p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>

        {/* CSS for desktop column-first layout */}
        <style>{`
          @media (min-width: 768px) {
            .campaign-grid {
              grid-auto-flow: column;
              grid-template-rows: repeat(6, auto);
            }
          }
        `}</style>

        {/* Instagram CTA */}
        <ScrollReveal delay={600}>
          <div className="text-center mt-10">
            <a 
              href="https://instagram.com/personaajans" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#F5C518] hover:text-yellow-400 transition-colors text-base md:text-lg font-medium"
            >
              <Instagram size={20} />
              {t.instagramCta}
              <span className="ml-1">→</span>
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default CampaignExamples;
